import { productApiClient } from '@/clients/ProductAPIClient';
import { ISalesTeam } from '@/data/models/salesTerritory';
import { useQuery, UseQueryResult } from '@tanstack/react-query';

export default function useGetSalesTeamsQuery(): UseQueryResult<
  ISalesTeam[],
  Error
> {
  return useQuery({
    queryKey: ['sales-teams'],
    queryFn: async () => {
      const response = await productApiClient.getAllSalesTeams();
      return response.data || [];
    },
    staleTime: Infinity,
  });
}
